import '../App.css';
import Heading from '../components/heading';
import Navigation from '../components/navigation';
import Footer from '../components/footer';



function director() {
  return (
    <div className="wrapper">
      <Heading />
      <Navigation />
      <div id="content">

        <h1>Bridge Directors in the Northern Territory</h1>

      <p>Bridge Directors play a vital role in the smooth, fair, and enjoyable running of duplicate bridge across the Northern Territory. Whether overseeing club sessions, congresses, or special events, Directors are responsible for applying the Laws of Duplicate Bridge, resolving irregularities, and ensuring that all players compete on an equal footing.</p>

      <p>Beyond rulings at the table, Director’s support clubs by managing movements, scoring, timekeeping, and procedural matters, often volunteering their time and expertise. They help create a welcoming and respectful playing environment, balancing technical knowledge with diplomacy and clear communication.</p>

      <p> The NTBA is committed to supporting and developing Directors in the NT. If you wish to start your Director journey, you can either reach out to your local club or contact the NTBA via email president.ntba@gmail.com.</p>

      <p> To advance your journey in becoming an accredited Director, you can attempt our online Director Quiz here. <a href="https://docs.google.com/forms/d/e/1FAIpQLSfR75oaGkWBq_fW7HJnGwUs6RGuxcocIA-6LxIjvTtxai5KGg/viewform">Online director quiz</a></p>

      </div>


      
      <Footer/>
    </div>
  );
}

export default director;